exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message-base-panel .wats-on-xmas-day-title{margin-top:25px}.error-message-base-panel .wats-on-xmas-day-description{margin-top:20px}.error-message-base-panel .wats-on-xmas-day-button{margin-bottom:15px}.mobile-layout .error-message-base-panel .wats-on-xmas-day-title,.mobile-layout .error-message-base-panel .wats-on-xmas-day-description{margin-top:20px}", ""]);

// exports
